import { render, staticRenderFns } from "./DailyUnitsPerTerminal.vue?vue&type=template&id=78cc0cfc&scoped=true"
import script from "./DailyUnitsPerTerminal.vue?vue&type=script&lang=js"
export * from "./DailyUnitsPerTerminal.vue?vue&type=script&lang=js"
import style0 from "./DailyUnitsPerTerminal.vue?vue&type=style&index=0&id=78cc0cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cc0cfc",
  null
  
)

export default component.exports